import { useRouteChangeStatus } from "@/hooks";
import Image from "next/legacy/image";
export default function PlayerThumbnail({ poster, watch, mediaLoaded, state }) {
  const { isRouting } = useRouteChangeStatus();

  const showThumbnail = poster && !mediaLoaded && !state?.overlay && !isRouting;

  return (
    <div>
      {showThumbnail && !!poster && (
        <Image
          src={poster}
          alt={"thumbnail"}
          layout="fill"
          objectFit="contain"
        ></Image>
      )}
    </div>
  );
}
